import * as React from "react";

import type {
  RibbonButtonProps,
  RibbonButtonState,
} from "../../RibbonButton/next";
import { useRibbonControlLabel } from "../../RibbonButton/next";
import { useRibbonButtonVariant } from "../../RibbonButton/next/useRibbonButtonVariant";

// eslint-disable-next-line no-restricted-imports
import { useAppSplitButtonPrimaryButton } from "@1js/acui-button/lib/Next";
import { useCommonRibbonButtonLabelClassNames } from "../../next/commonRibbonButtonStyles.styles";

export const useRibbonSplitButtonPrimaryButton = (
  props: RibbonButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { dataAutomationType, label, onRenderText, size, variant, variantId } =
    props;

  const ribbonLabel = useRibbonControlLabel(
    label,
    size,
    onRenderText,
    useCommonRibbonButtonLabelClassNames(size)
  );

  const state = useAppSplitButtonPrimaryButton(
    {
      ...props,
      children: size !== "large" ? ribbonLabel : <React.Fragment />,
      dataAutomationType: dataAutomationType ?? "RibbonButton",
    },
    ref
  );

  useRibbonButtonVariant(
    state as RibbonButtonState,
    variant as RibbonButtonState["variant"],
    variantId as RibbonButtonState["variantId"]
  );

  return state;
};
